/**
 * 状态变更弹窗
 * 6 种 action：
 *  - submit_rectify  (3→1)  需备注
 *  - submit_appeal   (3→5)  需备注
 *  - review_pass     (4→2)  仅确认
 *  - review_reject   (4→3)  需备注（驳回原因）
 *  - appeal_pass     (5→2)  仅确认
 *  - appeal_reject   (5→3)  需备注（驳回原因）
 */
import React, { useEffect, useState } from 'react'
import { Modal, Input } from 'antd'
import { CheckActionConfig } from '../constants/check'

const { TextArea } = Input

interface StatusActionModalProps {
  visible: boolean
  action: CheckActionConfig | null
  /** 当前操作的记录摘要（标题展示用） */
  recordSummary?: string
  submitting?: boolean
  onCancel: () => void
  onConfirm: (remark: string) => void
}

const StatusActionModal: React.FC<StatusActionModalProps> = ({
  visible,
  action,
  recordSummary,
  submitting,
  onCancel,
  onConfirm
}) => {
  const [remark, setRemark] = useState('')

  useEffect(() => {
    if (visible) setRemark('')
  }, [visible])

  if (!action) return null

  const needRemark = !action.confirmOnly
  const handleOk = () => {
    if (needRemark && !remark.trim()) {
      return
    }
    onConfirm(remark.trim())
  }

  return (
    <Modal
      title={action.label}
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      okText="确认"
      cancelText="取消"
      confirmLoading={submitting}
      okType={action.danger ? 'danger' : 'primary'}
      okButtonProps={{ disabled: needRemark && !remark.trim() }}
      destroyOnHidden
    >
      {recordSummary && (
        <div
          style={{
            background: '#FAFAFA',
            border: '1px solid #F0F0F0',
            borderRadius: 6,
            padding: '8px 12px',
            marginBottom: 12,
            fontSize: 13,
            color: 'rgba(0,0,0,0.65)'
          }}
        >
          {recordSummary}
        </div>
      )}
      {action.confirmOnly ? (
        <p style={{ margin: 0 }}>{action.confirmTip || '确认执行此操作？'}</p>
      ) : (
        <>
          <div style={{ marginBottom: 8, fontSize: 13 }}>
            {action.confirmTip || '请填写备注'}
            <span style={{ color: '#F5222D', marginLeft: 4 }}>*</span>
          </div>
          <TextArea
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            rows={4}
            maxLength={500}
            placeholder="请输入备注说明（必填）"
          />
          <div
            style={{
              textAlign: 'right',
              fontSize: 12,
              color: 'rgba(0,0,0,0.45)',
              marginTop: 4
            }}
          >
            {remark.length}/500
          </div>
        </>
      )}
    </Modal>
  )
}

export default StatusActionModal
